import React from 'react';
import { Tooltip, Spin } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';
import { useCallCenterOptional } from '../../contexts/CallCenterContext';

const ClickToCallButton = ({
  phone,
  className = '',
  disabled = false,
  size = 'sm',
}) => {
  const callCenter = useCallCenterOptional();

  if (!phone?.trim() || !callCenter?.isCallCenterActive) return null;

  const { clickToCall, isCalling } = callCenter;
  const loading = isCalling(phone);
  const sizeClass = size === 'md' ? 'w-8 h-8' : 'w-6 h-6';
  const iconSize = size === 'md' ? 14 : 12;

  return (
    <Tooltip title="تماس با یک کلیک">
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled && !loading) clickToCall(phone);
        }}
        disabled={disabled || loading}
        className={`inline-flex items-center justify-center ${sizeClass} rounded-full text-white bg-gradient-to-br from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 shadow-sm shadow-emerald-500/30 hover:shadow-emerald-500/50 transition-all border-0 p-0 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
        aria-label="تماس"
      >
        {loading ? (
          <Spin size="small" className="[&_.ant-spin-dot-item]:bg-white" />
        ) : (
          <PhoneOutlined style={{ fontSize: iconSize }} />
        )}
      </button>
    </Tooltip>
  );
};

export default ClickToCallButton;
